<template>
    <div>
        <el-card class="box-card box-cards" shadow="never">
            <el-row>
                <el-form :inline="true" class="user-search">
                    <el-col :span="24">
                        <el-form-item>
                            <div class="card_top"><span>管理员列表</span></div>
                        </el-form-item>
                        <el-form-item label="搜索：">
                            <el-input size="small" v-model="formInline.params.keyword" placeholder="输入关键字"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-card>
        <el-card class="box-card box-cards2" shadow="never">
            <!--列表-->
            <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
                style="width: 100%; " v-loading="loading">
                <el-table-column prop="id" label="Uid" align="center" width="140"></el-table-column>
                <el-table-column prop="account" label="账户" align="center"></el-table-column>
                <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
                <el-table-column prop="image" label="头像" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.avatar" alt="" srcset="" width="60" height="60" />
                    </template>
                </el-table-column>
                <el-table-column prop="is_show" label="状态" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.status == 0 ? '禁用' : '正常' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.createdAt | timestampToTime }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="操作" align="center">
                    <template slot-scope="scope">
                        <div v-if="isSuper">
                            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                            <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除 </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-card>
        <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
            custom-class="demo-drawer" ref="drawer" size="40%">
            <div class="demo-drawer__content">
                <el-row>
                    <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
                        <el-col :span="22">
                            <div class="grid-content bg-purple">
                                <el-form-item label="账号" prop="account">
                                    <el-input v-model="editForm.params.account" placeholder="请输入账号"></el-input>
                                </el-form-item>
                                <el-form-item label="昵称" prop="nickname">
                                    <el-input v-model="editForm.params.nickname" placeholder="请输入词书描述"></el-input>
                                </el-form-item>
                                <el-form-item label="头像：" prop="avatar">
                                    <el-upload class="avatar-uploader" name="files" :action="imagesrc"
                                        :headers="uploadHeader" :show-file-list="false" :on-success="licenseSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="editForm.params.avatar" :src="editForm.params.avatar" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="手机" prop="mobile">
                                    <el-input v-model="editForm.params.mobile" placeholder="请输入手机"></el-input>
                                </el-form-item>
                                <el-form-item label="邮箱" prop="email">
                                    <el-input v-model="editForm.params.email" placeholder="请输入邮箱"></el-input>
                                </el-form-item>


                                <el-form-item label="改密码" prop="password">
                                    <el-input v-model="editForm.params.password" placeholder="不修改请留空"></el-input>
                                </el-form-item>

                                <el-form-item label="状态" prop="status">
                                    <el-radio-group v-model="editForm.params.status">
                                        <el-radio :label="0">禁用</el-radio>
                                        <el-radio :label="1">正常</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-form>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="handleClose">取消</el-button>
                    <el-button size="small" type="goon" :loading="loading" class="title"
                        @click="submitForm('editForm')">
                        保存</el-button>
                </div>
                <div style="height: 60px; margin-top: 50px"></div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import { managerslist, managersstatus, managerscreate, managersupdate, managersdelete, managersbatchdelete, imagesrc, getUploadHeader } from "../../api/userMG";
export default {
    data() {
        return {

            //分页
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10,
            },
            loading: false,
            tableData: [], //表格数据 
            formInline: {
                data: {},
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    keyword: ""
                },
            },
            imagesrc: imagesrc,
            uploadHeader: {},
            title: '',
            editFormVisible: false,
            editForm: {
                data: {},
                params: {
                    "id": 0,
                    "account": "",
                    "password": "",
                    "nickname": "",
                    "mobile": "",
                    "email": "",
                    "avatar": '',
                    "type": 0,
                    "status": 1
                },
            },
            isSuper: 0,
            rules: {},
        };
    },
    components: {
        Pagination
    },
    created() {
        this.imagesrc = imagesrc;
        this.uploadHeader = getUploadHeader()
        this.isSuper = this.$store.state.user.type == 1;
        //数据列表
        this.getlist(this.formInline);
    },
    methods: {
        headStyle() {
            return {
                background: "#A1BBFF",
                color: "#fff",
                letterSpacing: "2px",
                border: " 1px solid #A1BBFF",
                textAlign: "center",
                height: "39px",
            };
        },

        //显示数据
        getlist(parameter) {
            this.loading = true;
            managerslist(parameter)
                .then((res) => {
                    this.loading = false;
                    // console.log("userlist", res);
                    if (res.code != 200) {
                        this.$message({
                            type: "info",
                            message: res.message,
                        });
                    } else {
                        this.tableData = res.data.records;
                        // 分页赋值
                        this.pageparm.currentPage = this.formInline.params.pageNum;
                        this.pageparm.pageSize = this.formInline.params.pageSize;
                        this.pageparm.total = res.data.total;
                        // console.log(this.tableData)
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("加载失败，请稍后再试！");
                });
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.params.pageNum = parm.currentPage;
            this.formInline.params.pageSize = parm.pageSize;
            this.getlist(this.formInline);
        },
        // 搜索事件
        search() {
            this.formInline.params.pageNum = 1;
            this.getlist(this.formInline); //显示
        },
        //上传头像
        licenseSuccess(response, file) {
            this.editForm.params.avatar = response.data[0].url
        },
        //限制上传的文件
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 格式或者png格式!');
            }
            return isJPG || isPNG;
        },
        handleClose() {
            this.$confirm("还有未保存的工作哦确定关闭吗？")
                .then((_) => {
                    this.editFormVisible = false
                    // done();
                })
                .catch((_) => { });
        },
        handleEdit(index, row) {
            this.editFormVisible = true;
            if (row != undefined && row != "undefined") {//修改
                this.title = '编辑管理员'
                this.editForm = {

                    data: {},
                    params: {
                        "id": 0,
                        "account": row.account,
                        "password": '',
                        "nickname": row.nickname,
                        "mobile": row.mobile,
                        "email": row.email,
                        "avatar": row.avatar,
                        "type": row.type,
                        "status": row.status,
                    },
                }

            } else {
                this.title = '添加管理员'
                this.editForm = {
                    data: {},
                    params: {
                        "id": 0,
                        "account": "",
                        "password": "",
                        "nickname": "",
                        "mobile": "",
                        "email": "",
                        "avatar": '',
                        "type": 0,
                        "status": 1
                    },
                }

            }
        },
        submitForm() {
            debounce(() => {
                var data = JSON.parse(JSON.stringify(this.editForm))

                if (data.params.id == 0) {
                    managerscreate(data)
                        .then(res => {
                            if (res.code == 200) {
                                this.editFormVisible = false;
                                this.getlist(this.formInline);
                                this.$message({
                                    message: "保存成功！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.$message.error("保存失败，请稍后再试！");
                        });

                } else {
                    managersupdate(data)
                        .then(res => {
                            if (res.code == 200) {
                                this.editFormVisible = false;
                                this.getlist(this.formInline);
                                this.$message({
                                    message: "保存成功！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.$message.error("保存失败，请稍后再试！");
                        });

                }


            }, 1500);
        },
        handleDel(id) {
            let data = {
                "data": {},
                "params": { "id": id },
            }
            this.$confirm("确定要删除吗?", "信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    managersdelete(data) //删除
                        .then((res) => {
                            console.log("d", res);
                            if (res.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.getlist(this.formInline);
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            //this.loading = false;
                            this.$message.error("删除失败，请稍后再试！");
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        }

    },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.divBox {
    /*flex-direction: row;*/
    float: left;
    position: relative;
    margin-right: 10px;
}

.imgSty {
    margin-left: 3px;
}

.delIcon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 145px;
    height: 145px;
    line-height: 145px;
    text-align: center;
}

.avatar {
    width: 145px;
    height: 145px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/managers/list.vue